import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import isEqual from 'react-fast-compare';
import { styled, StyleSheet, useToken, text, margin } from '@rexlabs/styling';
import { useField } from '@rexlabs/react-forms';
import Box from '@rexlabs/box';
import Tooltip from '@rexlabs/tooltip';
import InfoIconSvg from '@rexlabs/icons/info-filled.svg';
var defaultStyles = StyleSheet({
  field: _objectSpread(_objectSpread({
    width: '100%'
  }, margin.styles({
    target: 'field',
    all: 'none',
    bottom: 's'
  })), {}, {
    maxWidth: function maxWidth(_ref) {
      var token = _ref.token;
      return token('field.maxWidth', '40rem');
    },
    '&:last-child': _objectSpread({}, margin.styles({
      target: 'field.last',
      all: 'none'
    }))
  }),
  fullWidth: {
    maxWidth: function maxWidth(_ref2) {
      var token = _ref2.token;
      return token('field.fullWidth.maxWidth', '100%');
    }
  },
  label: _objectSpread({}, text.styles({
    target: 'field.label',
    fallback: 'small.semibold'
  })),
  optional: _objectSpread({}, text.styles({
    target: 'field.optionalText',
    fallback: 'small.default',
    color: function color(_ref3) {
      var token = _ref3.token;
      return token('color.textStyle.body.subtext');
    }
  })),
  description: _objectSpread({}, text.styles({
    target: 'field.description',
    fallback: 'small.default',
    color: function color(_ref4) {
      var token = _ref4.token;
      return token('color.textStyle.body.subtext');
    }
  })),
  helpContent: _objectSpread(_objectSpread({}, text.styles({
    target: 'field.helpContent',
    fallback: 'small.default',
    color: function color(_ref5) {
      var token = _ref5.token;
      return token('color.textStyle.body.subtext');
    }
  })), {}, {
    '& a': _objectSpread(_objectSpread({}, text.styles({
      target: 'field.helpContent.link',
      fallback: 'link.default.idle'
    })), {}, {
      '&:hover': _objectSpread({}, text.styles({
        target: 'field.helpContent.link.hover',
        fallback: 'link.default.hover'
      }))
    })
  }),
  error: _objectSpread({}, text.styles({
    target: 'field.error',
    fallback: 'small.default',
    color: function color(_ref6) {
      var token = _ref6.token;
      return token('color.textStyle.body.error');
    }
  }))
});

function _Field(_ref7) {
  var s = _ref7.styles,
      optional = _ref7.optional,
      _ref7$optionalText = _ref7.optionalText,
      optionalText = _ref7$optionalText === void 0 ? 'optional' : _ref7$optionalText,
      label = _ref7.label,
      description = _ref7.description,
      maxWidth = _ref7.maxWidth,
      fullWidth = _ref7.fullWidth,
      inputProps = _ref7.inputProps,
      input = _ref7.input,
      meta = _ref7.meta,
      actions = _ref7.actions,
      Input = _ref7.Input,
      HelpContent = _ref7.HelpContent,
      HelpTooltipContent = _ref7.HelpTooltipContent,
      props = _objectWithoutProperties(_ref7, ["styles", "optional", "optionalText", "label", "description", "maxWidth", "fullWidth", "inputProps", "input", "meta", "actions", "Input", "HelpContent", "HelpTooltipContent"]);

  var token = useToken();
  var id = input.id,
      name = input.name;
  var touched = meta.touched,
      error = meta.error,
      isValidating = meta.isValidating;
  var InfoIcon = token('field.infoIcon', InfoIconSvg);
  var showLabel = label || optional || HelpTooltipContent || HelpContent;
  var fullOptionalText = label ? "\u2014 ".concat(optionalText) : optionalText;
  var showError = touched && error;
  var modMeta = useMemo(function () {
    return _objectSpread(_objectSpread({}, meta), {}, {
      error: showError ? error : null
    });
  }, [meta, error, showError]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, s.with('field', {
    fullWidth: fullWidth
  })({
    maxWidth: maxWidth
  }), {
    "data-form-field-name": name
  }), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    spacing: token('spacing.xxs')
  }, showLabel && /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "center",
    flex: 1
  }, label && /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: id
  }, s('label')), label), optional && /*#__PURE__*/React.createElement("span", s('optional'), fullOptionalText)), /*#__PURE__*/React.createElement(Box, _extends({}, s('helpContent'), {
    alignItems: "center",
    flexDirection: "row"
  }), HelpContent && /*#__PURE__*/React.createElement(HelpContent, _extends({}, props, {
    isValidating: isValidating
  })), HelpTooltipContent && /*#__PURE__*/React.createElement(Tooltip, {
    Content: HelpTooltipContent
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    flex: 0
  }, /*#__PURE__*/React.createElement(InfoIcon, null))))), /*#__PURE__*/React.createElement(Input, _extends({}, inputProps, input, {
    meta: modMeta,
    actions: actions
  })), (showError || description) && (showError ? /*#__PURE__*/React.createElement(Box, s('error'), error) : description && /*#__PURE__*/React.createElement(Box, s('description'), description))));
}

var MemoField = React.memo(styled(defaultStyles)(_Field), isEqual);

function Field(_ref8) {
  var id = _ref8.id,
      name = _ref8.name,
      initialValue = _ref8.initialValue,
      sendImmediate = _ref8.sendImmediate,
      onFocus = _ref8.onFocus,
      onChange = _ref8.onChange,
      onBlur = _ref8.onBlur,
      validate = _ref8.validate,
      isInlineLabel = _ref8.isInlineLabel,
      props = _objectWithoutProperties(_ref8, ["id", "name", "initialValue", "sendImmediate", "onFocus", "onChange", "onBlur", "validate", "isInlineLabel"]);

  var _useField = useField(name, {
    id: id,
    initialValue: initialValue,
    sendImmediate: sendImmediate,
    validate: validate,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur
  }),
      _useField2 = _slicedToArray(_useField, 3),
      input = _useField2[0],
      meta = _useField2[1],
      actions = _useField2[2];

  return /*#__PURE__*/React.createElement(MemoField, _extends({}, props, {
    input: input,
    meta: meta,
    actions: actions
  }));
}

export default Field;